<template>
    <div>
        <breadcrumbs class="mb-3" />
        <page-title :text="$t('page_titles.all_companies_page_title')" />
        <file-download-modal
            v-if="authStore.isTO1"
            v-model="isShowDownloadExcelMenu"
            data-cy="download-file"
            :radio-items="[]"
            :label="$t('companies_download')"
            :loading="isLoadingDownloadExcel"
            class="mb-2"
            @download="downloadFile"
        />
        <all-companies-table
            :company-type="[
                Company.TourAgency,
                Company.TourOperator,
                Company.Corporator,
                Company.HubSupplier,
                Company.InternalSupplier,
            ]"
        />
    </div>
</template>

<script setup lang="ts">
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'
    import AllCompaniesTable from '~/components/account/companies/AllCompaniesTable.vue'
    import {Company} from '~/utils/types/types'
    import FileDownloadModal from '~/components/account/snippets/FileDownloadModal.vue'
    import PageTitle from '~/components/parts/PageTitle.vue'
    import {downloadData} from '~/utils/helpers'

    const isShowDownloadExcelMenu = ref<boolean>(false)
    const isLoadingDownloadExcel = ref<boolean>(false)

    const app = useNuxtApp()
    const {t} = useI18n()

    const downloadFile = async format => {
        isLoadingDownloadExcel.value = true
        try {
            const data = await app.$api.downloadCompanies.get({
                filterKey: runtimeStore.companiesFilterKey,
                fileType: format.fileType,
            })

            downloadData(data, 'companies.xlsx')
            isShowDownloadExcelMenu.value = false
        } catch (e) {
            app.$toast.error(t('error_message.load_error'))
        } finally {
            isLoadingDownloadExcel.value = false
        }
    }
</script>
